<template>
  <div class="containerTable">
    <vxe-toolbar id="toolbarId_odel0" :custom="{storage: true}" export :refresh="{query: RefreshList}">
      <template v-slot:buttons>
        <el-button @click="funcFilter">查询</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table 
      ref="xTable" 
      border 
      highlight-hover-row
      row-id="id" 
      class="mytable-footer" 
      height="80%" 
      align="center" 
      :loading="loading" 
      :data="tableData" 
      sort-config.remote
      export-config 
      show-overflow
      @sort-change="sortList"
    >
      <vxe-table-column field="invoiceNum" title="发票号码" min-width="200" sortable />
      <vxe-table-column field="enStation" title="入口收费站" min-width="240" sortable />
      <vxe-table-column field="exStation" title="出口收费站" min-width="240" sortable />
      <vxe-table-column field="exTime" title="交易时间" min-width="240" sortable />
      <vxe-table-column field="amount" title="金额" min-width="160" sortable />
      <vxe-table-column field="fee" title="交易金额" min-width="160" sortable />
      <vxe-table-column field="totalTaxAmount" title="税额（可抵扣金额）" min-width="240" sortable />
      <vxe-table-column field="plateNum" title="车牌号" min-width="160" sortable />
      <vxe-table-column field="sellerName" title="销方名称" min-width="240" sortable />
      <vxe-table-column field="waybillStatus" title="开票状态" min-width="120" sortable>
        <template v-slot="{row}">
          {{ row.waybillStatus==3?"开票完成":"开票中" }}
        </template>
      </vxe-table-column>
      <vxe-table-column field="transactionId" title="交易ID" min-width="260" sortable />
      <vxe-table-column title="操作" fixed="right" min-width="150">
        <template slot-scope="scope">
          <el-button type="primary" @click="funcSubmit(scope.row.invoiceUrl)">下载发票</el-button>
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
import { orderDetailEtcInvoice, splitOrderFindInvoice } from "@/api/etc";

export default {
  name: "OrderDetailEtcInvoice",
  data() {
    return {
      code:'',
      isLong: false,
      loading: false,
      tableData: [],
      listQuery: {},
      form: {},
    };
  },
  created() {},
  methods: {
    findInfo(code,isLong){
      this.code = code
      this.isLong = isLong
      this.findList()
    },
    async findList() {
      this.tableData = [];
      this.loading = true
      let reponse = this.isLong? await splitOrderFindInvoice({code:this.code}): await orderDetailEtcInvoice({code:this.code})
      this.loading = false
      this.$message.warning(reponse.msg)
      this.tableData = reponse.data
    },
    funcSubmit(invoiceUrl) {
      if (invoiceUrl) {
        window.open(invoiceUrl);
      } else {
        this.$message.error("未生成ETC发票！");
      }
    },
  },
};
</script>

<style scoped>
</style>
